'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _ = require('lodash');
var ConfigurationService = function ConfigurationService($window, App, bootstrapFeaturesService) {
  function getMarkets() {
    return App.markets;
  }
  function getMarketGroup() {
    return App.foMarketGroupType;
  }
  function getMarketsGenerateNewCancel() {
    return App.marketsGenerateNewCancel;
  }
  function getLegs() {
    return App.legs;
  }
  function getEntities() {
    return App.entities;
  }
  function getSeasons() {
    return App.seasons;
  }
  function getClassGroups() {
    var classGroups = App.classGroups && App.classGroups.all || [];
    return _.cloneDeep(classGroups);
  }
  function getClassGroupsByMarket(market, fcrTag) {
    var classGroups = App.classGroups && (App.classGroups[fcrTag] || App.classGroups[market] || App.classGroups.all) || [];
    return _.cloneDeep(classGroups);
  }
  function getClassGroupMapping(market) {
    var mapping = App.classGroupMapping && (App.classGroupMapping[market] || App.classGroupMapping["default"]) || {};
    return _.cloneDeep(mapping);
  }
  function getClassIndexMapping(leg, fcrTag) {
    var mapping = App.classesIndexesMapping && (App.classesIndexesMapping[fcrTag] || App.classesIndexesMapping[leg] || App.classesIndexesMapping["default"]) || {};
    return _.cloneDeep(mapping);
  }
  function getAllClassesIndexMapping(fcrTag) {
    return getClassIndexMapping('all', fcrTag);
  }
  function getCabinIndexMapping(leg) {
    var mapping = App.cabinsIndexesMapping && (App.cabinsIndexesMapping[leg] || App.cabinsIndexesMapping["default"]) || {};
    return _.cloneDeep(mapping);
  }
  function getCabins() {
    return _.cloneDeep(App.cabins || []);
  }
  function getDisplayableCabins() {
    var displayableCabinSequence = getHepMap().DISPLAYABLE_CABIN_SEQUENCE;
    var displayableCabins = displayableCabinSequence ? _.split(displayableCabinSequence, ',') : '';
    return _.cloneDeep(displayableCabins || App.cabins || []);
  }
  function getDemandDistributionType() {
    return getHepMap().DEMAND_DISTRIBUTION_TYPE;
  }
  function isDemandDistributionIncremental() {
    return _.includes(['DISTRIBUTE_INCREMENTAL_DEMAND_USING_CCM', 'DISTRIBUTE_INCREMENTAL_DEMAND_USING_FARE_ELASTICITY'], getHepMap().DEMAND_DISTRIBUTION_TYPE);
  }
  function getClasses() {
    return _.cloneDeep(App.classes || []);
  }
  function getFlightNumbers() {
    return App.flightNumbers;
  }
  function getFlightDowGroups() {
    return App.flightDowGroups;
  }
  function getMarketDowGroups() {
    return App.marketDowGroups;
  }
  function getOperatingCarriers() {
    return App.operatingCarriers;
  }
  function getPoses() {
    return App.poses;
  }
  function getDaPoses() {
    return App.daPoses;
  }
  function getMarketTiers() {
    return App.marketTiers;
  }
  function getFoPoses() {
    return App.foPoses;
  }
  function getUserId() {
    return App.userFactory && App.userFactory.getUserId();
  }
  function getUserDisplayName() {
    return App.userFactory && App.userFactory.getDisplayName();
  }
  function getAllUsers() {
    return App.userList;
  }
  function getAllNonAdminUsers() {
    return App.nonAdminUserList;
  }
  function getOptimizationRules() {
    return App.optimizationRulesList;
  }
  function getClassGroupConfig() {
    return _.cloneDeep(App.classGroupConfig || {});
  }
  function getFcrConfig() {
    return _.cloneDeep(App.fcrConfig || []);
  }
  function getClassGroupConfigDefault() {
    var classGroupConfig = App.classGroupConfig && App.classGroupConfig["default"] || [];
    return _.cloneDeep(classGroupConfig);
  }
  function getClassGroupConfigByMarket(classGroupIndicesKey) {
    var config = App.classGroupConfig && getClassGroupConfigForCorrectHepLevel(classGroupIndicesKey) || {};
    return _.cloneDeep(config);
  }
  function getClassGroupConfigForCorrectHepLevel(classGroupIndicesKey) {
    return App.classGroupConfig[classGroupIndicesKey] || App.classGroupConfig[getKeyWithoutFCRTag(classGroupIndicesKey)] || App.classGroupConfig["default"];
  }
  function getKeyWithoutFCRTag(classGroupIndicesKey) {
    if (!_.isNil(classGroupIndicesKey)) {
      var keyParts = classGroupIndicesKey.split('-');
      if (keyParts.length > 2) {
        return keyParts[0] + '-' + keyParts[1];
      }
    }
    return classGroupIndicesKey;
  }
  function getServiceTypes() {
    return App.serviceTypes || ['Direct', 'Not Direct'];
  }
  function getDefaultDaysOffsets() {
    return App.defaultDaysOffsets || [1, 7, 30, 60, 90];
  }
  function getEvents() {
    return _.cloneDeep(App.events || []);
  }
  function getHostShare() {
    return _.cloneDeep(App.hostShare || []);
  }
  function getCurtainRuleIds() {
    return _.cloneDeep(App.curtainRuleIds || []);
  }
  function getFlightCategories() {
    return _.cloneDeep(App.flightCategories || []);
  }
  function getHostAndSubsidiaryCarriers() {
    return [getHostCarrier()].concat(App.subsidiaryCarriers);
  }
  function getHepMap() {
    return App.hep || {};
  }
  function getHepDAMap() {
    return App.hepDA || {};
  }
  function isDirectionalPpsEnabled() {
    return getHepDAMap().DYNAMIC_PRICING_DIRECTIONAL_PPS_STRATEGY || false;
  }
  function isPosControlEnabled() {
    return getHepDAMap().DYNAMIC_PRICING_YIELD_ALL_POSES_CONTROL || false;
  }
  function getRecommendedFrequency() {
    return getHepDAMap().DYNAMIC_PRICING_RECOM_FREQUENCY || 1;
  }
  function getRecommendedFrequencyOld() {
    return getHepDAMap().DYNAMIC_PRICING_RECOM_FREQUENCY_OLD || 1;
  }
  function getRecommendedDatapull() {
    return getHepDAMap().DYNAMIC_PRICING_RECOM_DATAPULL || 24;
  }
  function getFOSimpleHep() {
    return App.foSimpleHep || {};
  }
  function getSystemProperties() {
    return App.systemProperties || {};
  }
  function getTimeOfDayBucketSize() {
    return getHepMap().TIME_OF_DAY_BUCKET_SIZE || 8;
  }
  function getDistanceUnit() {
    return getHepMap().DISTANCE_UNIT || '';
  }
  function getNumberOfAllowedScenarios() {
    return getHepMap().MAX_NUMBER_SCENARIOS || 3;
  }
  function getHostCarrier() {
    return $window.sessionStorage.getItem('carrierCode') || '';
  }
  function getBenchmarkCarriers() {
    return App.benchmarkCarriers;
  }
  function getTimingsEnabled() {
    return getHepMap().TIMINGS_ENABLED || false;
  }
  function getMaxDtd() {
    return getHepMap().MAX_DTD || 330;
  }
  function getStrategyDomainLevel() {
    return getHepMap().STRATEGY_DOMAIN_LEVEL || '';
  }
  function getCurrencySymbol() {
    return getHepMap().CURRENCY_SYMBOL || '$';
  }
  function getATPCOTimeZone() {
    return getHepMap().FO_DEFAULT_ATPCO_TIME_ZONE || 'America/New_York';
  }
  function getAssignedMarkets() {
    var assignedMarkets = getHepMap().ASSIGNED_MARKETS || '';
    return assignedMarkets.split(/,/).sort();
  }
  function getHubs() {
    return _.cloneDeep(App.hubs || []);
  }
  function isOnlyApproverPos() {
    return _.clone(App.isOnlyApproverPos);
  }
  function getMarketsOrLegsFromHub(isLegs) {
    var hubs = getHubs();
    var entities = isLegs ? getLegs() : getMarkets();
    var origin = _.get(_.first(hubs), 'station');
    var entitiesFromHub;
    if (!_.isEmpty(hubs) && origin) {
      entitiesFromHub = _.chain(entities).filter({
        origin: origin
      }).filter(function (e) {
        return getFeatures().DYNAMIC_AVAILABILITY || isLegs || isSignificantOrLocal(e);
      }).map(function (e) {
        return e.origin + '-' + e.destination;
      }).value();
    }
    return _.isEmpty(entitiesFromHub) ? null : entitiesFromHub;
  }
  function getSsiUrl() {
    return getHepMap().SSI_URL || '';
  }
  function getROMColorConfiguration() {
    return _.cloneDeep(App.ROMColorConfiguration);
  }
  function getROMWeekEndDOW() {
    return getHepMap().ROM_WEEK_END_DOW || 'SAT';
  }
  function getLastROMDate() {
    return getSystemProperties().LAST_ROM_DATE;
  }
  function getROMMaxRangeSummaryWeeks() {
    return getHepMap().ROM_MAX_RANGE_SUMMARY_WEEKS || 52;
  }
  function getROMMaxSelectSummaryWeeks() {
    return getHepMap().ROM_MAX_SELECT_SUMMARY_WEEKS || 12;
  }
  function getROMMaxSelectAnalysisWeeks() {
    return getHepMap().ROM_MAX_SELECT_ANALYSIS_WEEKS || 4;
  }
  function getROMMaxRangeAnalysisWeeks() {
    return getHepMap().ROM_MAX_RANGE_ANALYSIS_WEEKS || 12;
  }
  function getROMMaxReferenceWeeks() {
    return getHepMap().ROM_MAX_REFERENCE_WEEKS || 12;
  }
  function getRTPS() {
    return getHepMap().ROM_RTPS || '0,10,50,200,300';
  }
  function getParsedRTPS() {
    var RTPS = getRTPS().split(',').map(Number);
    var buckets = [];
    for (var i = 0, RTPSLength = RTPS.length; i < RTPSLength - 1; i++) {
      buckets.push(RTPS[i] + '-' + (RTPS[i + 1] - 1));
    }
    buckets.push(RTPS[i] + '-330');
    return buckets;
  }
  function getFeatures() {
    return bootstrapFeaturesService.getFeatures();
  }
  function getHelpUrl() {
    return getHepMap().HELP_URL;
  }
  function isSignificantOrLocal(m) {
    return m.isSignificant || m.isLocal;
  }
  function getNonCodeShareMarkets() {
    return getFeatures().DYNAMIC_AVAILABILITY || getFeatures().FARES_OPTIMIZER ? getMarkets() : _.filter(getMarkets(), isSignificantOrLocal);
  }
  var compareMarkets = _.curry(function (one, two) {
    return one.origin === two.origin && one.destination === two.destination;
  });
  function isNonCodeShareMarket(item) {
    return _.some(getNonCodeShareMarkets(), compareMarkets(item));
  }
  function getLegKey(m) {
    return m.origin + m.destination;
  }
  function getNonCodeShareLegs() {
    var result = [];
    var legs = getLegs();
    if (_.isArray(legs)) {
      var nonCodeShareMarketsMap = _.keyBy(getNonCodeShareMarkets(), getLegKey);
      for (var i = 0; i < legs.length; i++) {
        var elem = legs[i];
        if (nonCodeShareMarketsMap[getLegKey(elem)]) {
          result.push(elem);
        }
      }
    }
    return result;
  }
  function getFoMaxStayGroups() {
    return _.cloneDeep(App.FOMaxStayGrouping) || [];
  }
  function getFoMinStayGroups() {
    return _.cloneDeep(App.FOMinStayGrouping) || [];
  }
  function getUserPrimaryPOSLevel() {
    return _.cloneDeep(App.primaryLevelPos) || [];
  }
  function getUserLastPOSLevel() {
    return _.cloneDeep(App.lastLevelPos) || [];
  }
  function getFoAdvPurchaseGroups() {
    return _.cloneDeep(App.FOAdvancePurchaseGrouping) || [];
  }
  function getFoSeasonDefinitions() {
    return _.cloneDeep(App.seasonDefinitions) || {};
  }
  function getFoUseSeasonIndicator() {
    return getFOSimpleHep().FO_SEASON_MATCH_USE_SEASON_INDICATOR;
  }
  function getFoFareBasisCodeSeasonPosition() {
    return getFOSimpleHep().FO_SEASON_MATCH_FBC_CHAR;
  }
  function getConfiguredHostCarriers() {
    return getFOSimpleHep().FO_HOST_CARRIER;
  }
  function getFoGrouping(type) {
    return _.chain(App).get(type + '.grouping').cloneDeep().value() || [];
  }
  function getFoRejectionReasons() {
    return _.cloneDeep(App.foRejectionReasons) || [];
  }
  function getFoRecommendationLadderStatuses() {
    return _.cloneDeep(App.foRecommendationLadderStatuses) || [];
  }
  function getFoSmoothingMethods() {
    return _.cloneDeep(App.foSmoothingMethods) || [];
  }
  function getInterfaceStatusFileEvents() {
    var result = [];
    if (getFeatures().DYNAMIC_AVAILABILITY) {
      result = _.concat(result, ['FOFM_CURRENCY_EXCHANGE_RATES', 'SHOPPING', 'INFARE', 'YIELDS', 'AVERAGEFARE', 'UNIQUEPRESENCE', 'SCHEDULE', 'ACTIVERECOMMENDATIONS', 'C2CLOADEDUPSELL', 'P2PLOADEDUPSELL', 'BUY_DOWN', 'INVENTORY', 'OD_AVAILABILITY', 'PRICE_RECOMMENDATION_BOOKING_CURVE', 'PRICE_RECOMMENDATION_SEASON_ASSIGNMENT', 'PRICE_RECOMMENDATION_FORECASTED_LF', 'PRICE_RECOMMENDATION_PNR', 'VM_REPORT', 'SHOP_REPORT', 'EXCLUDED_RECOMMENDATIONS']);
    }
    if (getFeatures().FARES_OPTIMIZER) {
      result = _.concat(result, ['FOWEBFARE', 'FOFM_CURRENCY_EXCHANGE_RATES', 'FO_FM_OUTBOUND_REQUEST', 'FO_DELTA_LAKE_FARE_LOAD_TRIGGER']);
    }
    return result;
  }
  function getFoBenchmarkCarriers() {
    return _.cloneDeep(App.foBenchmarkCarriers) || [];
  }
  function getFoBenchmarkCarrierToMarketMap() {
    return _.cloneDeep(App.foBenchmarkCarrierToMarketMap) || [];
  }
  function getFoAirportRegionMapping() {
    return _.cloneDeep(App.foAirportRegionMapping) || [];
  }
  function getFoCountries() {
    return _.cloneDeep(App.foCountries) || [];
  }
  function getFoRegions() {
    return _.cloneDeep(App.foRegions) || [];
  }
  function getFoCabins() {
    return _.cloneDeep(App.foCabins) || [];
  }
  function getFoRbds() {
    return _.cloneDeep(App.foRbds) || [];
  }
  function getFoCategoryCabinRbdsMapping() {
    return _.cloneDeep(App.foCategoryCabinRbds) || [];
  }
  function getRbdsByCarrierCategoryCabin() {
    return _.cloneDeep(App.foRbdsByCarrierCategoryCabin) || [];
  }
  function getFoCityCodes() {
    return _.cloneDeep(App.foCityCodes) || [];
  }
  function getFoAirportCodes() {
    return _.cloneDeep(App.foAirportCodes) || [];
  }
  function getFoCurrencies() {
    return _.cloneDeep(App.foCurrencies) || [];
  }
  function getFoTariffRules() {
    return _.cloneDeep(App.foTariffMatrix) || [];
  }
  function getFoFareTariffCode(fareTariffNumber) {
    if (fareTariffNumber || fareTariffNumber === 0) {
      var firstTariffMatrixPropertiesFromSearch = _.find(App.tariffMatrixProperties, function (tariffMatrixProperty) {
        return parseInt(tariffMatrixProperty.fareTariffNumber) === fareTariffNumber;
      });
      return _.cloneDeep([firstTariffMatrixPropertiesFromSearch.fareTariffCode]) || [];
    }
    return _.cloneDeep(App.tariffMatrixProperties) || [];
  }
  function getAllFareTariffNumber() {
    var allFareTariffNumber = _.transform(_.cloneDeep(App.tariffMatrixProperties), function (result, current) {
      result.push(current.fareTariffNumber);
    });
    return applyIncludedTariffNumberFilter(allFareTariffNumber);
  }
  function getAllFareTariffNumberByTariffCode(fareTariffCode) {
    var firstTariffMatrixPropertiesFromSearch = _.find(App.tariffMatrixProperties, function (tariffMatrixProperty) {
      return tariffMatrixProperty.fareTariffCode === fareTariffCode;
    });
    var allFareTariffNumber = _.cloneDeep([firstTariffMatrixPropertiesFromSearch.fareTariffNumber]) || [];
    return applyIncludedTariffNumberFilter(allFareTariffNumber);
  }
  function applyIncludedTariffNumberFilter(allFareTariffNumber) {
    if (!_.isEmpty(App.includedTariffs)) {
      return _.filter(allFareTariffNumber, function (tariffNumber) {
        return App.includedTariffs.includes(tariffNumber);
      });
    }
    return allFareTariffNumber;
  }
  function getFoFareTariffMatrix() {
    return _.cloneDeep(App.tariffMatrixProperties) || [];
  }
  function getTariffs(publicOrPrivate) {
    return _.filter(App.tariffMatrixProperties, function (tariffMatrixProperty) {
      return tariffMatrixProperty.publicOrPrivate === publicOrPrivate;
    }).map(function (tariffMatrix) {
      return tariffMatrix.fareTariffNumber;
    });
  }
  function getFoShortRecommendationReasons() {
    return _.cloneDeep(App.foShortRecommendationReasons) || [];
  }
  function getDefaultWorkflowSettings() {
    return _.cloneDeep(App.defaultWorkflowSettings);
  }
  function getFlightTags() {
    return _.cloneDeep(App.flightTags) || [];
  }
  function getFlightTagNames() {
    return _.cloneDeep(App.flightTagNames) || [];
  }
  function getFoFareBrandDefinitions() {
    return _.cloneDeep(App.fareBrandDefinitionProperties) || [];
  }
  function getDAFareBrandDefinitions() {
    return _.cloneDeep(App.daFareBrandDefinition) || {};
  }
  function getDAFareBrandNormalizations() {
    return _.cloneDeep(App.daFareBrandNormalization) || {};
  }
  function getDAFareBrandAssignments() {
    return _.cloneDeep(App.daFareBrandAssignment) || {};
  }
  function getFoFareBrandsForHostCarrier() {
    var fareBrandsByCarrier = _.cloneDeep(App.fareBrandDefinitionProperties) || [];
    if (!_.isNil($window.sessionStorage.getItem('carrierCode'))) {
      var hostCarrier = $window.sessionStorage.getItem('carrierCode').split(',');
      return _.transform(fareBrandsByCarrier, function (result, current) {
        if (_.includes(hostCarrier, current.carrier)) {
          _.forEach(_.chain(current.fareBrands).map('fareBrand').value(), function (fareBrand) {
            result.push(fareBrand);
          });
        }
      });
    }
  }
  function getMarketForecastType(market) {
    var splittedMarket = market.split('-');
    var selectedMarket = _.find(App.markets, {
      origin: splittedMarket[0],
      destination: splittedMarket[1]
    });
    return _.get(selectedMarket, 'forecastType', 'Market');
  }
  function getFoCategoryCabinRbds(rowData, foCategoryCabinRbdsMapping, categoryCabinRbdKey) {
    var editedCabin = rowData.foCabin ? rowData.foCabin : rowData.cabin;
    if (_.isEmpty(categoryCabinRbdKey)) {
      return getDefaultCabinRbds(foCategoryCabinRbdsMapping, rowData.category, editedCabin);
    }
    var rbds = !_.isNil(foCategoryCabinRbdsMapping[categoryCabinRbdKey][rowData.category]) && !_.isNil(foCategoryCabinRbdsMapping[categoryCabinRbdKey][rowData.category][editedCabin]) ? foCategoryCabinRbdsMapping[categoryCabinRbdKey][rowData.category][editedCabin] : getDefaultCabinRbds(foCategoryCabinRbdsMapping, rowData.category, editedCabin);
    return (0, _toConsumableArray2["default"])(new Set(rbds));
  }
  function getDefaultCabinRbds(rbdsByCarrierCategoryCabin, category, cabin) {
    var rbds = [];
    _.forEach(rbdsByCarrierCategoryCabin, function (cabinMap) {
      rbds = rbds.concat(cabinMap[category][cabin]);
    });
    return (0, _toConsumableArray2["default"])(new Set(rbds));
  }
  function getAirportCountryCodes() {
    return _.filter(App.airportCountryCodes, function (code) {
      return code.match('^[A-Z0-9]{2}$');
    });
  }
  return {
    getMarkets: getMarkets,
    getMarketGroup: getMarketGroup,
    getMarketsGenerateNewCancel: getMarketsGenerateNewCancel,
    getNonCodeShareMarkets: getNonCodeShareMarkets,
    isNonCodeShareMarket: isNonCodeShareMarket,
    getLegs: getLegs,
    getNonCodeShareLegs: getNonCodeShareLegs,
    getEntities: getEntities,
    getSeasons: getSeasons,
    getClassGroups: getClassGroups,
    getClassGroupsByMarket: getClassGroupsByMarket,
    getClassGroupMapping: getClassGroupMapping,
    getClassIndexMapping: getClassIndexMapping,
    getAllClassesIndexMapping: getAllClassesIndexMapping,
    getCabinIndexMapping: getCabinIndexMapping,
    getCabins: getCabins,
    getDisplayableCabins: getDisplayableCabins,
    getClasses: getClasses,
    getMaxDtd: getMaxDtd,
    getFlightNumbers: getFlightNumbers,
    getFlightDowGroups: getFlightDowGroups,
    getMarketDowGroups: getMarketDowGroups,
    getPoses: getPoses,
    getMarketTiers: getMarketTiers,
    getUserId: getUserId,
    getUserDisplayName: getUserDisplayName,
    getAllUsers: getAllUsers,
    getAllNonAdminUsers: getAllNonAdminUsers,
    getOptimizationRules: getOptimizationRules,
    getClassGroupConfigDefault: getClassGroupConfigDefault,
    getClassGroupConfig: getClassGroupConfig,
    getFcrConfig: getFcrConfig,
    getClassGroupConfigByMarket: getClassGroupConfigByMarket,
    getServiceTypes: getServiceTypes,
    getEvents: getEvents,
    getHostShare: getHostShare,
    getHepMap: getHepMap,
    getTimeOfDayBucketSize: getTimeOfDayBucketSize,
    getDistanceUnit: getDistanceUnit,
    getNumberOfAllowedScenarios: getNumberOfAllowedScenarios,
    getHostCarrier: getHostCarrier,
    getConfiguredHostCarriers: getConfiguredHostCarriers,
    getBenchmarkCarriers: getBenchmarkCarriers,
    getTimingsEnabled: getTimingsEnabled,
    getStrategyDomainLevel: getStrategyDomainLevel,
    getAssignedMarkets: getAssignedMarkets,
    getSsiUrl: getSsiUrl,
    getROMColorConfiguration: getROMColorConfiguration,
    getROMWeekEndDOW: getROMWeekEndDOW,
    getLastROMDate: getLastROMDate,
    getROMMaxRangeSummaryWeeks: getROMMaxRangeSummaryWeeks,
    getROMMaxSelectSummaryWeeks: getROMMaxSelectSummaryWeeks,
    getROMMaxSelectAnalysisWeeks: getROMMaxSelectAnalysisWeeks,
    getROMMaxRangeAnalysisWeeks: getROMMaxRangeAnalysisWeeks,
    getROMMaxReferenceWeeks: getROMMaxReferenceWeeks,
    getRTPS: getRTPS,
    getParsedRTPS: getParsedRTPS,
    getFeatures: getFeatures,
    getCurrencySymbol: getCurrencySymbol,
    getOperatingCarriers: getOperatingCarriers,
    getHelpUrl: getHelpUrl,
    getMarketsOrLegsFromHub: getMarketsOrLegsFromHub,
    getHostAndSubsidiaryCarriers: getHostAndSubsidiaryCarriers,
    getFoMaxStayGroups: getFoMaxStayGroups,
    getFoMinStayGroups: getFoMinStayGroups,
    getFoAdvPurchaseGroups: getFoAdvPurchaseGroups,
    getFoSeasonDefinitions: getFoSeasonDefinitions,
    getFoUseSeasonIndicator: getFoUseSeasonIndicator,
    getFoFareBasisCodeSeasonPosition: getFoFareBasisCodeSeasonPosition,
    getFoGrouping: getFoGrouping,
    getCurtainRuleIds: getCurtainRuleIds,
    getFlightCategories: getFlightCategories,
    getDefaultDaysOffsets: getDefaultDaysOffsets,
    getUserPrimaryPOSLevel: getUserPrimaryPOSLevel,
    getUserLastPOSLevel: getUserLastPOSLevel,
    getFoRejectionReasons: getFoRejectionReasons,
    getFoRecommendationLadderStatuses: getFoRecommendationLadderStatuses,
    isOnlyApproverPos: isOnlyApproverPos,
    getInterfaceStatusFileEvents: getInterfaceStatusFileEvents,
    getFoSmoothingMethods: getFoSmoothingMethods,
    getFoBenchmarkCarriers: getFoBenchmarkCarriers,
    getFoAirportRegionMapping: getFoAirportRegionMapping,
    getFoCountries: getFoCountries,
    getFoRegions: getFoRegions,
    getFoCabins: getFoCabins,
    getFoRbds: getFoRbds,
    getFoCityCodes: getFoCityCodes,
    getDefaultWorkflowSettings: getDefaultWorkflowSettings,
    getFoAirportCodes: getFoAirportCodes,
    getFoPoses: getFoPoses,
    getDaPoses: getDaPoses,
    getFoBenchmarkCarrierToMarketMap: getFoBenchmarkCarrierToMarketMap,
    getFoCurrencies: getFoCurrencies,
    getFlightTags: getFlightTags,
    getFlightTagNames: getFlightTagNames,
    getATPCOTimeZone: getATPCOTimeZone,
    getFoShortRecommendationReasons: getFoShortRecommendationReasons,
    getFoFareBrandDefinitions: getFoFareBrandDefinitions,
    getFoFareBrandsForHostCarrier: getFoFareBrandsForHostCarrier,
    isDirectionalPpsEnabled: isDirectionalPpsEnabled,
    isPosControlEnabled: isPosControlEnabled,
    getDemandDistributionType: getDemandDistributionType,
    isDemandDistributionIncremental: isDemandDistributionIncremental,
    getMarketForecastType: getMarketForecastType,
    getRecommendedFrequency: getRecommendedFrequency,
    getRecommendedFrequencyOld: getRecommendedFrequencyOld,
    getRecommendedDatapull: getRecommendedDatapull,
    getFoCategoryCabinRbdsMapping: getFoCategoryCabinRbdsMapping,
    getRbdsByCarrierCategoryCabin: getRbdsByCarrierCategoryCabin,
    getFoCategoryCabinRbds: getFoCategoryCabinRbds,
    getDAFareBrandDefinitions: getDAFareBrandDefinitions,
    getDAFareBrandNormalizations: getDAFareBrandNormalizations,
    getDAFareBrandAssignments: getDAFareBrandAssignments,
    getAirportCountryCodes: getAirportCountryCodes,
    getFoTariffRules: getFoTariffRules,
    getFoFareTariffCode: getFoFareTariffCode,
    getFoFareTariffMatrix: getFoFareTariffMatrix,
    getAllFareTariffNumber: getAllFareTariffNumber,
    getAllFareTariffNumberByTariffCode: getAllFareTariffNumberByTariffCode,
    getTariffs: getTariffs
  };
};
ConfigurationService.$inject = ['$window', 'App', 'BootstrapFeaturesService'];
module.exports = ConfigurationService;